// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"9024b57e0b23ded381fc","691":"35ed2b1301aa8a8152d3"}[chunkId] + ".js";
};